<template>
    <v-navigation-drawer v-model="$parent.$parent.drawer" app  :mini-variant="mini" @click.prevent>

        <!-- <span class="ico_menu" @click.stop="mini = !mini"></span> -->

            <v-btn
                v-if="!$parent.$parent.isMobile"
                width="100%"
                tile
                v-model="mini"
                plain
                class="d-flex "
                :class="[!mini ? 'mr-0 justify-end ' : 'pr-6' ]" 
                @click.stop="mini = !mini"
            >
                <!-- <v-icon :color="pantone"> {{mini ? 'mdi-chevron-right' : 'mdi-chevron-left' }} </v-icon> -->
                <div width="100%">
                    <v-img
                        class="ico_drawer_item"
                        contain
                        :src="$renderImageFromAssets('icon_menu_burger')"
                        transition="scale-transition"
                        max-width="30"
                    >
                                    <!-- <template><div class="text-subtitle-1 text-center pt-1"><i class="fas fa-shopping-cart"></i></div></template> -->
                    </v-img>
                </div>
            </v-btn>

        <v-list >
            <v-list-item link :to="{ name: 'processes'}" color="primary" @click="filterProceduresList(FILTER_STATUS_NEW)">
                <v-list-item-action>
                    <img v-if="currentFilter===FILTER_STATUS_NEW" class="ico_drawer_item" :src="$renderImageFromAssets('icon_new_process_selected')"/>
                        <img v-else class="ico_drawer_item"  :src="$renderImageFromAssets('icon_new_process')"/>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>Nuevo trámite</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item-group v-model="currentFilter" color="primary">
                <v-list-item @click="filterProceduresList(FILTER_STATUS_ALL)" :key="FILTER_STATUS_ALL" >
                    <v-list-item-action>
                        <img v-if="currentFilter===FILTER_STATUS_ALL" class="ico_drawer_item" :src="$renderImageFromAssets('icon_all_selected')"/>
                        <img v-else class="ico_drawer_item"  :src="$renderImageFromAssets('icon_all')"/>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Mis trámites</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item @click="filterProceduresList(FILTER_STATUS_ACTIVE)" :key="FILTER_STATUS_ACTIVE">
                    <v-list-item-action>
                        <img v-if="currentFilter===FILTER_STATUS_ACTIVE" class="ico_drawer_item" :src="$renderImageFromAssets('icon_pending_selected')"/>
                        <img v-else class="ico_drawer_item"  :src="$renderImageFromAssets('icon_pending')"/>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Pendientes</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item @click="filterProceduresList(FILTER_STATUS_IN_PROCESS)" :key="FILTER_STATUS_IN_PROCESS">
                    <v-list-item-action>
                        <img v-if="currentFilter===FILTER_STATUS_IN_PROCESS" class="ico_drawer_item" :src="$renderImageFromAssets('icon_in_process_selected')"/>
                        <img v-else class="ico_drawer_item"  :src="$renderImageFromAssets('icon_in_process')"/>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>En proceso</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item link @click="filterProceduresList(FILTER_STATUS_CANCELED)" :key="FILTER_STATUS_CANCELED">
                    <v-list-item-action>
                        <img v-if="currentFilter===FILTER_STATUS_CANCELED" class="ico_drawer_item" :src="$renderImageFromAssets('icon_canceled_selected')"/>
                        <img v-else class="ico_drawer_item"  :src="$renderImageFromAssets('icon_canceled')"/>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Cancelados</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item link @click="filterProceduresList(FILTER_STATUS_FINISHED)" :key="FILTER_STATUS_FINISHED">
                    <v-list-item-action>
                        <img v-if="currentFilter===FILTER_STATUS_FINISHED" class="ico_drawer_item" :src="$renderImageFromAssets('icon_finished_selected')"/>
                        <img v-else class="ico_drawer_item"  :src="$renderImageFromAssets('icon_finished')"/>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Completados</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item link :to="{ name: 'orders', params: {action: 'list'} }"  @click="filterProceduresList(FILTER_STATUS_ORDER)" :key="FILTER_STATUS_ORDER">
                    <v-list-item-action>
                        <img v-if="currentFilter===FILTER_STATUS_ORDER" class="ico_drawer_item" :src="$renderImageFromAssets('icon_orders_selected')">
                        <img v-else class="ico_drawer_item"  :src="$renderImageFromAssets('icon_orders')">
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Mis órdenes</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

            </v-list-item-group>
        </v-list>

        <!-- <div class="footer_menu">
            <div class="redes_sociales">
                <a href="https://www.facebook.com/gobiernonuevoleon/" target="_blank"><span class="btn-face"></span></a>
                <a href="https://twitter.com/nuevoleon" target="_blank"><span class="btn-twitter"></span></a>
                <a href="https://www.instagram.com/nuevoleonmx/" target="_blank"><span class="btn-insta"></span></a>
                <a href="https://www.youtube.com/user/GobiernoNuevoLeon" target="_blank"><span class="btn-youtube"></span></a>
                <a href="https://t.me/gobnl" target="_blank"><span class="btn-telegram2"></span></a>
            </div>
            <p>Ayuda:
                <a href="tel:070" id="step11">070 opción 8</a>
                <a href="javascript:void(0);" onclick="javascript:startIntro();"></a>
                <!-- <a href="https://wa.me/5218120331341" target="_Blank">
                <span class="btn-whatsapp"></span>
                </a> -->
                </p>
            <p>
                <a href="https://funcionario.nl.gob.mx/assets/pdf/terminos_condiciones.pdf" target="_blank">Condiciones de uso</a>
            </p>
            <p>Todos los Derecho Reservados</p>
            <p>© 2022 Gobierno de Nuevo León</p>
        </div> -->

        <transition name="fade">
            <v-card v-if="!mini" class="px-4" style="position:absolute;bottom:70px;width:100%">
                <v-card class="d-flex" flat>
                    <div class="redes_sociales" style="border-bottom: 1px solid #e8e8e8;border-top: 1px solid #e8e8e8;">
                        <a href="https://www.facebook.com/070nuevoleon/" target="_blank" class="py-2">
                            <!-- <img  v-if="face" class="ico_drawer_item"  :src="$renderImageFromAssets('facebook')"/> -->
                            <img class="ico_drawer_item"  :src="$renderImageFromAssets('facebook_active')"/>
                        </a>
                        <a  href="https://twitter.com/070nuevoleon" target="_blank">
                            <!-- <img v-if="twitter" class="ico_drawer_item"  :src="$renderImageFromAssets('twitter')"/> -->
                            <img class="ico_drawer_item"  :src="$renderImageFromAssets('twitter_active')"/>
                        </a>
                        <a href="https://www.instagram.com/070nuevoleon/" target="_blank">
                            <!-- <img v-if="instagram" class="ico_drawer_item"  :src="$renderImageFromAssets('instagram')"/> -->
                            <img class="ico_drawer_item"  :src="$renderImageFromAssets('instagram_active')"/>
                        </a>
                        <a href="https://www.youtube.com/user/GobiernoNuevoLeon" target="_blank">
                            <!-- <img v-if="youtube" class="ico_drawer_item"  :src="$renderImageFromAssets('youtube')"/> -->
                            <img class="ico_drawer_item"  :src="$renderImageFromAssets('youtube_active')"/>
                        </a>
                        <a href="https://t.me/gobnl" target="_blank">
                            <!-- <img v-if="telegram" class="ico_drawer_item"  :src="$renderImageFromAssets('telegram')"/> -->
                            <img class="ico_drawer_item"  :src="$renderImageFromAssets('telegram_active')"/>
                        </a>
                    </div>
                </v-card>
                <div class="text-footer-sidebar mt-2">Teléfono: <a href="tel: 070">070</a><!-- <a href="https://wa.me/5218120331341"><img class="ico_drawer_item mx-2" :src="$renderImageFromAssets('whatsapp_active')" > </a> --> </div>
                <div class="text-footer-sidebar">Correo: <a class="text-decoration-none text--secondary d-flex align-center" href="mailto: 070@nuevoleon.gob.mx" target="_blank">070@nuevoleon.gob.mx</a></div>
                <div class="text-footer-sidebar">Redes sociales: @070nuevoleon</div>
                <div class="text-footer-sidebar"><a class="text-decoration-none text--secondary d-flex align-center" href="https://funcionario.nl.gob.mx/assets/pdf/terminos_condiciones.pdf" target="_blank">Términos y Condiciones  <img  class="ico_drawer_item mx-2"  :src="$renderImageFromAssets('terminos')"/> </a></div>
                <div class="text-footer-sidebar"><a class="text-decoration-none text--secondary d-flex align-center" href="https://www.nl.gob.mx/es/aviso-de-privacidad-integral-de-ventanilla-de-tramites-acceso-para-el-registro-de-usuarios" target="_blank"> Aviso de Privacidad <img  class="ico_drawer_item mx-2"  :src="$renderImageFromAssets('aviso')"/> </a> </div>
                <div class="text-footer-sidebar">Todos los Derechos Reservados</div>
                <div class="text-footer-sidebar">© 2022 Gobierno de Nuevo León</div>
            </v-card>
        </transition>
        <v-card v-if="mini"  style="position:absolute;bottom:70px;width:100%">
            <v-card class="d-flex justify-center my-3" flat> 
                <!-- <a href="https://wa.me/5218120331341"> 
                    <img  class="ico_drawer_item "  :src="$renderImageFromAssets('whatsapp_active')"/>
                </a> -->
            </v-card>
            <v-card class="d-flex justify-center  my-3" flat> 
                <a href="https://funcionario.nl.gob.mx/assets/pdf/terminos_condiciones.pdf" target="_blank"> 
                    <img  class="ico_drawer_item "  :src="$renderImageFromAssets('terminos')"/>
                </a>
            </v-card>
            <v-card class="d-flex justify-center  my-3" flat> 
                <a href="https://www.nl.gob.mx/es/aviso-de-privacidad-integral-de-ventanilla-de-tramites-acceso-para-el-registro-de-usuarios" targer="_blank">
                    <img  class="ico_drawer_item "  :src="$renderImageFromAssets('aviso')"/>
                </a>
            </v-card>
        </v-card>
    </v-navigation-drawer>
</template>

<script>
    import {mapState, mapActions} from 'vuex';
    import router from "@/router";

    import {procedureListRequest} from "bestgob-core/api/models";
import Vue from 'vue';

    export default {
        data(){
            return {
                //era
                currentFilter: -1,

                FILTER_STATUS_ALL: 0,
                FILTER_STATUS_ACTIVE: 1,
                FILTER_STATUS_FINISHED: 2,
                FILTER_STATUS_CANCELED: 3,
                FILTER_STATUS_DELETED: 4,
                FILTER_STATUS_IN_PROCESS: 5,
                FILTER_STATUS_ORDER: 6,
                FILTER_STATUS_NEW: 7,

                // currentFilter: -1,

                // FILTER_STATUS_ALL: 0,
                // FILTER_STATUS_ACTIVE: 1,
                // FILTER_STATUS_FINISHED: 4,
                // FILTER_STATUS_CANCELED: 3,
                // FILTER_STATUS_DELETED: 5,
                // FILTER_STATUS_IN_PROCESS: 2,
                // FILTER_STATUS_ORDER: 6,
                // FILTER_STATUS_NEW: 7,
                drawer: true,
                mini: false,
                pantone: '#B08C55',
                pantoneBlack: '#15212F',
                face: true,
                whatsapp: true,
                instagram: true,
                twitter: true,
                telegram: true,
                youtube: true,
            }
        },

        computed: {
            ...mapState({accountStore: state => state.account, proceduresStore: state => state.procedures}),
        },

        mounted() {
            this.currentFilter = this.proceduresStore.filterStatus
        },

        watch:{
            '$parent.$parent.drawer'(){
                if (this.$parent.$parent.drawer ){
                    this.mini = false    
                }
            },
            currentFilter(){
                this.mini == true ? Vue.nextTick( ()=> {this.mini = true} ) : '' 
                Vue.nextTick( ()=> {this.currentFilter == 2 ? this.currentFilter = 5 : '' })
                // Vue.nextTick( ()=> {this.currentFilter == 4 ? this.currentFilter = 2 : '' })
            }
        },

        methods: {
            ...mapActions('procedures', ['getProceduresByUser']),
    
            filterProceduresList(filterStatus) {
                this.currentFilter = filterStatus
                // console.log('id en data',this.currentFilter);
                if (filterStatus < 6 && router.currentRoute.name !== 'home'){
                    router.push({name: 'home'})
                }
                

                // if (filterStatus !== this.proceduresStore.filterStatus) {
                    let request = procedureListRequest()
                    request.userId = this.accountStore.user.id
                    request.status = filterStatus
                    request.limit = this.proceduresStore.pageLimit
                    this.getProceduresByUser(request)
                // }
            },
            onResize() {
                if (window.innerWidth < 769){
                    this.$parent.$parent.isMobile = true ;
                    this.mini = false;
                } 
                else this.$parent.$parent.isMobile = false;
            },
        }
    }
</script>

<style scoped>
    
    .ico_drawer_item{
        width: 24px;
        height: 24px;
    }
    
    /*.ico_menu{
        background-image: url("../assets/img/menu.png");
        background-size: cover;
        display: inline-block;
        position: relative;
        text-align: right;
        top: 10px;
        left: 215px;
        width: 24px;
        height: 24px;
    }*/

    .v-navigation-drawer--mini-variant .ico_menu{
        transform: translateX(-200px);
        transition: 0.2s ease-in-out;
    }

    .v-navigation-drawer{
        top: 64px !important;
    }
    .v-list-item__title{
        font-family: 'PoppinsRegular' !important;
    }
</style>
